import React from 'react';
const logo = require('../assets/mysta.svg');

export function MystaIconButton(props: React.AnchorHTMLAttributes<any>) {
    return (
        <a {...props} className={`button is-white ${props.className}`} >
            <span className="icon is-small">
                <img src={logo} />
            </span>
        </a>
    );
}
